import { useEffect, useState } from 'react';
import {
  ensurePricebookCatalogSync,
  getPricebookVersion,
  subscribePricebookChanges,
} from '../lib/pricebook/pricebook';

export function usePricebookCatalogSync(): number {
  const [version, setVersion] = useState<number>(() => getPricebookVersion());

  useEffect(() => {
    let active = true;
    const unsubscribe = subscribePricebookChanges((nextVersion) => {
      if (active) {
        setVersion(nextVersion);
      }
    });
    void ensurePricebookCatalogSync().finally(() => {
      if (active) {
        setVersion(getPricebookVersion());
      }
    });
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return version;
}
